export default __webpack_public_path__ + "static/financial-info-bank-348dbec230b58dad29abe07a0ef99bf2.png";